import React, {Component} from 'react';
import { Platform, View, Image, Text, FlatList, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import { Button, } from "native-base";
import _ from 'lodash';

class VideoIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (<View style={this.props.style}>
                {this.props.onPress ?
                 (<TouchableOpacity style={{width: '100%', height: '100%'}}
                                    onPress={this.props.onPress}>
                  <Image style={{width: '100%', height: '100%'}}
                  source={this.props.disabled ?
                          require('../../images/video_disable.png') :
                          require('../../images/video_enable.png')}/>
                  </TouchableOpacity>) :
                 (<Image style={{width: '100%', height: '100%'}}
                  source={this.props.disabled ?
                          require('../../images/video_disable.png') :
                          require('../../images/video_enable.png')}/>)}
                </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default VideoIcon;
